import {TimeOnJobSite, SpacingOrFlowRate} from '@hconnect/tuc-processes/fields/loadSpacing/types'

import {formatMinutesToTimeString} from '../components/fields/Time/timeUtils'

/**
 * Helper function to get time-related parameters for API calls
 * Matches the API payload format from rmcOrderPlacementService
 */
export const getTimeRelatedParams = (
  timeOnJobSite: TimeOnJobSite | undefined,
  spacingOrFlowRate: SpacingOrFlowRate | undefined
): {
  loadSpace?: string
  flowRate?: number
  timeOnJobSite?: string
} => {
  const timeParams: {
    loadSpace?: string
    flowRate?: number
    timeOnJobSite?: string
  } = {}

  // Include timeOnJobSite if value exists
  if (timeOnJobSite?.time) {
    timeParams.timeOnJobSite = formatMinutesToTimeString(timeOnJobSite.time)
  }

  // Include flow rate related parameters if value exists
  if (spacingOrFlowRate) {
    if (spacingOrFlowRate.type === 'loadSpace') {
      // For spacing type, use loadSpace (string format)
      timeParams.loadSpace = formatMinutesToTimeString(spacingOrFlowRate.loadSpace)
    } else if (spacingOrFlowRate.type === 'flowRate') {
      // For flowRate type, use flowRate (number format)
      timeParams.flowRate = spacingOrFlowRate.flowRate
    }
  }

  return timeParams
}
